export default __webpack_public_path__ + "static/media/moon_phases.5de3aadc.woff2";